import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { UnitOfWorkService } from '../../services/unitOfWork/unitOfWork.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as _util from '../../services/utilities';
import * as _errorHandler from '../../services/errorhandler';
import { ApplicationInsightsService } from '../../services/appInsights/application-insights.service';
import { HttpEventType, HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { BusyService } from '../../services/busy.service';

@Component({
  selector: 'app-browse',
  templateUrl: './browse.component.html',
  styleUrls: ['./browse.component.css']
})
export class BrowseComponent implements OnInit {

	library: string;
	workspace: number;
	id: number;
	docid: number;
	sub: Subscription;
	doc: model.document;
	folder: model.folder;
	downloading: boolean = false;
	cache: { folder: Array<model.folder>, document: Array<model.document> }
		= { folder: [], document: [] };
	progress: number = 0;
	progressStyle: SafeStyle;

	handler = _errorHandler.includeIn(this);

	constructor(private route: ActivatedRoute, private uow: UnitOfWorkService, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private sanitizer: DomSanitizer, private ai: ApplicationInsightsService, private busy: BusyService) {
		ai.logPageView();
	}

	ngOnInit() {
		this.sub = this.route.params.subscribe(params => {
			this.library = params["library"];
			this.workspace = +params["workspace"];
			this.id = +params["id"];
			this.docid = +params["docid"];

			var cachedFolder = this.findInCache('folder', this.library, this.workspace, isNaN(this.id) ? -1 : this.id);
			if (cachedFolder) {
				this.folder = cachedFolder;
			}
            else {
                this.busy.set({ key: 'folder-load', isBusy: true, message: 'Loading Folder' });
				this.uow.browse(this.library, this.workspace, this.id)
					.then((data) => {
						//this.folder = null;
						if (data && data.length) {
							this.folder = data[0];
							this.cache.folder.push(this.folder);
						}
						else {
							throw "No data returned for folder";
                        }
                        this.busy.set({ key: 'folder-load', isBusy: false });
					})
                    .catch(reason => {
                        this.busy.set({ key: 'folder-load', isBusy: false });
						this.handler.handleError(reason);
					});
			}

			if (this.docid) {
				var doc: model.document = <model.document>{};
				doc.library = this.library;
				doc.id = this.docid;
				this.viewDocument(doc);
			}
		});
	}

	viewDocument(doc: model.document) {
		var cachedDoc = this.findInCache('document', doc.library, null, doc.id);
		if (cachedDoc) {
			this.doc = cachedDoc;
		}
        else {
            this.busy.set({ key: 'document-load', isBusy: true, message: 'Loading Document' });
			this.uow.documentView(doc.library, doc.id)
				.then((data) => {
					this.doc = null;
					if (data && data.length) {
						this.doc = data[0];
						this.cache.document.push(this.doc);
					}
					else {
						throw "No document data returned";
                    }
                    this.busy.set({ key: 'document-load', isBusy: false });
				})
                .catch(reason => {
                    this.busy.set({ key: 'document-load', isBusy: false });
					this.handler.handleError(reason);
				});
		}
	}

    downloadDocument(doc: model.document) {
        this.busy.set({ key: 'file-download', isBusy: true, message: 'Downloading file...' });
		this.ai.logPageView();
		this.downloading = true;
		this.progress = 0;
		this.progressStyle = this.sanitizer.bypassSecurityTrustStyle('width: ' + this.progress + '%');
		this.http.get(this.baseUrl + 'breeze/documentDownload?library=' + doc.library + '&id=' + doc.id,
			{ observe: 'events', responseType: 'blob', reportProgress: true })
			.subscribe(event => {
				try {
					if (event.type === HttpEventType.DownloadProgress) {
						this.progress = 100 / event.total * event.loaded;
						this.progressStyle = this.sanitizer.bypassSecurityTrustStyle('width: ' + this.progress + '%');
					}
					if (event.type === HttpEventType.Response) {
						saveAs(event.body, event.headers.get('X-Bdo-FileName'), {
							type: event.body.type
						});
                        this.downloading = false;
                        this.busy.set({ key: 'file-download', isBusy: false });
					}
				}
				catch (ex) {
                    this.downloading = false;
                    this.busy.set({ key: 'file-download', isBusy: false });
					this.handler.handleError(ex);
				}
			})
			/*.toPromise().then(resp => {
				saveAs(resp.body, resp.headers.get('X-Bdo-FileName'), {
					type: resp.body.type
				});
				this.downloading = false;
				_util.isBusy.set({ key: 'file-download', isBusy: false });
			}).catch(ex => {
				this.downloading = false;
				_util.isBusy.set({ key: 'file-download', isBusy: false });
				this.handler.handleError(ex);
			});*/
	}

    search(query: string) {
        this.busy.set({ key: 'search-load', isBusy: true, message: 'Searching' });
		this.uow.searchWorkspace(this.library, this.workspace, query)
			.then(data => {
				if (data && data.length) {
					this.folder = data[0];
				}
				else {
					throw "No data returned for folder";
                }
                this.busy.set({ key: 'search-load', isBusy: false });
			})
            .catch(reason => {
                this.busy.set({ key: 'search-load', isBusy: false });
				this.handler.handleError(reason);
			});
	}

	findInCache(name: string, library: string, workspace: number, id: number) {
		var c = this.cache[name];
		for (var i = 0; i < c.length; i++)
			if (c[i].library == library && (workspace == null || c[i].workspace == workspace) && c[i].id == id)
				return c[i];
		return null;
	}

	ngOnDestroy() {
		this.sub.unsubscribe();
	}

}
